export enum ÉtatSéquence {
  A_FAIRE = 'AFaire',
  EN_COURS = 'EnCours',
  TERMINEE = 'Terminee',
  DESACTIVEE = 'Desactivee',
}
